import apiService from './api-service';

export const limitService = {
	getLimits,
	createLimit,
	updateLimit,
	deleteLimit
};

async function getLimits() {
	const limits = await apiService.get('limit/getLimits');
	return limits;
}

async function createLimit(limit) {
	const countInsertedRows = await apiService.post('limit/createLimit', limit);
	return countInsertedRows;
}

async function updateLimit(limit) {
	const countUpdatedRows = await apiService.post('limit/updateLimit', limit);
	return countUpdatedRows;
}

async function deleteLimit(limitId) {
	const limit = { limitId: limitId };

	const countDeletedRows = await apiService.post('limit/deleteLimit', limit);
	return countDeletedRows;
}